export default __webpack_public_path__ + "static/media/allowancerules-icon.a66817a1.svg";